.centerHr {
	margin-top: 12px;
}

@media (max-width: 540px) {
	.title {
		font-size: 0.5rem;
	}
}
